export const lightTheme = {
  background: '#FAF8F3',
  switchBackground: '#FFFFFF',
  switch: '#FFCC33',
  highlight: '#9DC6F3',
  font: '#000000',
  switchLeft: '4px',
};

export const darkTheme = {
  background: '#404258',
  switchBackground: '#474E68',
  switch: '#FFCFDE',
  highlight: '#5566AA',
  font: '#FFFFFF',
  switchLeft: 'calc(100% - 40px)',
};
